var render, staticRenderFns
import script from "./PropertyValue.vue?vue&type=script&lang=js&"
export * from "./PropertyValue.vue?vue&type=script&lang=js&"
import style0 from "./PropertyValue.vue?vue&type=style&index=0&id=995a3746&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "995a3746",
  null
  
)

export default component.exports